export const DRAGGABLE_TYPE = {
  ENV_ROW: 'env_row',
  ENV_FROM_ROW: 'env_from_row',
};
